import type { FC } from "react";

import { useDispatch } from "react-redux";

import { toggleKeepSidebarOpened } from "app/actions/userData/primarySidebar3Actions";
import type { ISecondaryActionWrapper } from "app/components/sidebar3/primary-side-bar/types";
import { USER_CLOSED_ONBOARDING_HUB } from "app/pages/sales-intelligence/sub-modules/onboarding/constants/preferences";
import OnboardingHubContainer from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/containers/OnboardingHubContainer";
import WizardContainer from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/containers/WizardContainer";
import { PreferencesService } from "app/services/preferences/preferencesService";

export const OnboardingHub: FC<ISecondaryActionWrapper> = ({ onClick, onClose, isPrimarySidebarOpen }) => {
    const dispatch = useDispatch();
    const isUserClosedOnboardingHub = PreferencesService.get(USER_CLOSED_ONBOARDING_HUB);

    if (isUserClosedOnboardingHub) {
        return null;
    }
    return (
        <>
            <OnboardingHubContainer
                onClick={onClick}
                onClose={onClose}
                isShowHub={isPrimarySidebarOpen}
                onToggleHub={(isOpen) => {
                    dispatch(toggleKeepSidebarOpened(isOpen));
                }}
            />
            <WizardContainer />
        </>
    );
};
